import { render, staticRenderFns } from "./ModalPasswordEdit.vue?vue&type=template&id=247f7d56&"
import script from "./ModalPasswordEdit.vue?vue&type=script&lang=js&"
export * from "./ModalPasswordEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports